export default __webpack_public_path__ + "static/media/hand.cc23be51.svg";